import * as mutationTypes from './mutation-types'
import api from '@/store/api/sso'

const initialState = () => ({
    logs: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        logs: state => state.logs.data,
        pagination: state => state.logs.pagination
    },
    actions: {
        /**
         * @param {{}} data
         * @returns {Promise<*>}
         */
        listLogs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listLogs(data)

                commit(mutationTypes.SET_LOGS, response)
                
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetLogs: ({commit}) => commit(mutationTypes.RESET_LOGS)
    },
    mutations: {
        [mutationTypes.RESET_LOGS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_LOGS]: (state, data) => state.logs = data
    }
}
